import React, { useState, useEffect } from 'react';
import {
  Card,
  Button,
  Space,
  Typography,
  Modal,
  Form,
  Input,
  Table,
  Popconfirm,
  Tooltip
} from 'antd';
import {
  ReloadOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  LinkOutlined
} from '@ant-design/icons';
import { App as AntApp } from 'antd';
import { admin } from '../../services/api';

const { Title, Text } = Typography;

const PortalNfeIntegracao = () => {
  const { message } = AntApp.useApp();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [configs, setConfigs] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      setLoading(true);
      const data = await admin.getPortalNfeConfig();
      setConfigs(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error('Erro ao carregar configurações:', e);
      message.error('Erro ao carregar configurações');
    } finally {
      setLoading(false);
    }
  };

  const openCreate = () => {
    setEditing(null);
    form.resetFields();
    setModalOpen(true);
  };

  const openEdit = (record) => {
    setEditing(record);
    form.setFieldsValue({ endpointConsultaNfe: record.endpointConsultaNfe });
    setModalOpen(true);
  };

  const handleDelete = async (id) => {
    try {
      await admin.deletePortalNfeConfig(id);
      message.success('Configuração excluída com sucesso');
      load();
    } catch (e) {
      message.error(e.message || 'Erro ao excluir');
    }
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      if (editing) {
        await admin.updatePortalNfeConfig(editing.id, values);
        message.success('Configuração atualizada com sucesso');
      } else {
        await admin.createPortalNfeConfig(values);
        message.success('Configuração criada com sucesso');
      }
      setModalOpen(false);
      load();
    } catch (e) {
      message.error(e.message || 'Erro ao salvar');
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80
    },
    {
      title: 'Endpoint de Consulta NF-e',
      dataIndex: 'endpointConsultaNfe',
      key: 'endpointConsultaNfe',
      render: (value) => (
        <Space><LinkOutlined /> <Text code>{value}</Text></Space>
      )
    },
    {
      title: 'Criado em',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (value) => value ? new Date(value).toLocaleString('pt-BR') : '-'
    },
    {
      title: 'Ações',
      key: 'actions',
      width: 120,
      render: (_, record) => (
        <Space>
          <Tooltip title="Editar">
            <Button type="text" icon={<EditOutlined />} onClick={() => openEdit(record)} />
          </Tooltip>
          <Popconfirm
            title="Excluir configuração?"
            onConfirm={() => handleDelete(record.id)}
            okText="Sim"
            cancelText="Não"
            okButtonProps={{ danger: true }}
          >
            <Tooltip title="Excluir">
              <Button type="text" danger icon={<DeleteOutlined />} />
            </Tooltip>
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Portal NF-e</Title>
        <Space>
          <Button icon={<ReloadOutlined />} onClick={load} loading={loading}>Atualizar</Button>
          <Button type="primary" icon={<PlusOutlined />} onClick={openCreate}>Nova Configuração</Button>
        </Space>
      </div>
      <Card>
        <Table
          columns={columns}
          dataSource={configs}
          rowKey="id"
          loading={loading}
          pagination={{ pageSize: 10, showTotal: (total) => `Total: ${total}` }}
        />
      </Card>
      <Modal
        title={editing ? 'Editar Configuração' : 'Nova Configuração'}
        open={modalOpen}
        onCancel={() => setModalOpen(false)}
        footer={null}
        destroyOnClose
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit} style={{ marginTop: 16 }}>
          <Form.Item
            name="endpointConsultaNfe"
            label="Endpoint de Consulta NF-e"
            rules={[
              { required: true, message: 'Endpoint é obrigatório' },
              { type: 'url', message: 'URL inválida' }
            ]}
          >
            <Input placeholder="https://api.exemplo.com/consulta-nfe" />
          </Form.Item>
          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit" loading={loading}>Salvar</Button>
              <Button onClick={() => setModalOpen(false)}>Cancelar</Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default PortalNfeIntegracao;
